
export function getMap() {
    return elementsPageMap;
}
    
const elementsPageMap = {
    appointmentTypes: "#appointment-types",
    carrierOrganizations: "#carrierorganizations",
    shippingSection: ".shipping-section",
    loadType: ".load-type",
    floorLoaded: ".floor-loaded",
    loadTypeError: "#load-type-error",
    cases: ".cases",
    numberOfPallets: ".number-of-pallets",
    pallets: ".pallets",
    liveUnload: ".live-unload-message",
    dropUnload: ".drop-unload-message",
    pickupEmpty: ".pickup-message",
    palletsSection: ".pallets-section",
    merchant: ".merchant",
    casesSection: ".cases-section",
    asnRequiredError: "#asn-required-error",
    notes: ".notes",
    appDurationTime: "#app-duration",
    asnInvalidError: ".invalid-asn-error",
    asnDuplicateError: ".duplicate-asn-error",
    asnError: ".asn-error",
    asnGenericError: ".generic-asn-error",
    asnGenericErrorLabel: ".generic-asn-error-label",
    skuSection: ".sku-section",
    singleSku: ".single-sku",
    asn: ".asn",
    facSection: ".fac-section",
    asnDetails: ".asn-details",
    slotError: ".duplicate-slot-error",
    mixedSkus: ".mixed-skus",
    slotErrorMessage: ".slot-error-message",
    addAsnBtn: ".add-asn-btn",
    duplicateMessage: ".duplicate-error-message",
    differentType: ".different-type",
    arrivalTime: ".arrival-time-section",
    destinationSection: ".destination-section",
    additionalInfo: ".additional-info-section",
    inventorySection: ".inventory-section",
    heights: "#pallet-heights",
    cancelBtn: ".cancel-url",
    facilities: "#facilities",
    editMessage: ".edit-message",
    asnAlert: ".asn-alert",
    shippingAlert: ".shipping-alert",
    trailerTypes: "#trailerTypes",
    retailerList: "#retailerList",
    trailerNumber: ".trailer-number",
    trailerRequired: ".trailer-mandatory-sign",
    trailer: ".trailer",
    checkAppointmentBtn: "#check-appointment-btn",
    appointmentDate: "#appointment-date",
    nxtDayMsg: "#next-day-appointment-msg",
    oneHrMsg: "#appointment-time-1hr-msg",
    availableMsg: "#available-appointment-msg",
    disclaimerMsg: "#appointment-disclaimer-msg",
    asnId: ".asn-id",
    asnCarrier: ".asn-carrier",
    submitBtn: ".submit-appointment-btn",
    asnStatus: ".status",
    loadTypeBtnToggleEl: '.load-type-btn-toggle',
    inventorySkuBtnToggleEl: '.inventory-sku-btn-toggle',
    appointmentSchedulerContainer: '.appointment-scheduler'
};        



// WEBPACK FOOTER //
// ./src/pages/appointmentForm/elementsBindMap.js